type Handler = (params: Record<string, string>) => Promise<void> | void;
type Route = { pattern: RegExp; keys: string[]; handler: Handler };
const routes: Route[] = [];

export function route(path: string, handler: Handler) {
  const keys: string[] = [];
  const pattern = new RegExp('^' + path.replace(/:([a-zA-Z]+)/g, (_, k) => {
    keys.push(k);
    return '([^/]+)';
  }).replace(/\//g, '\\/') + '/?$');
  routes.push({ pattern, keys, handler });
}

export function navigate(to: string) {
  history.pushState({}, '', to);
  resolve();
}

export async function resolve() {
  const path = window.location.pathname;
  for (const r of routes) {
    const m = path.match(r.pattern);
    if (m) {
      const params: Record<string, string> = {};
      r.keys.forEach((k, i) => { params[k] = m[i + 1]; });
      await r.handler(params);
      return;
    }
  }
  const app = document.getElementById('app')!;
  app.innerHTML = '<h2>404</h2><p>Page not found.</p><p><a href="/">Home</a></p>';
}

document.addEventListener('click', (e) => {
  const target = (e.target as HTMLElement).closest('a');
  if (!target) return;
  const href = target.getAttribute('href');
  if (!href || href.startsWith('http') || href.startsWith('mailto:') || target.target === '_blank') return;
  e.preventDefault();
  navigate(href);
});
window.addEventListener('popstate', resolve);
